export interface TeamMember {
  id: string;
  name: string;
  title: string;
  bio: string;
  initials: string;
  linkedIn?: string;
  email?: string;
}

export interface Partner {
  id: string;
  name: string;
  category: string;
  logo?: string; // Optional path to partner logo image
  url?: string; // Optional website URL
  description?: string; // Optional description shown on hover
}

export const teamMembers: TeamMember[] = [
  {
    id: 'harry-webber',
    name: 'Harry Webber',
    title: 'Co-Founder',
    bio: 'With over 25 years of experience in Caribbean luxury development, Harry brings a visionary approach to creating communities that blend modern living with island charm. His previous projects have set new standards for sustainable, high-end residential developments. Passionate about creating spaces where people truly want to live, work, and thrive.',
    initials: 'HW',
    linkedIn: 'https://linkedin.com/',
    email: 'harry.webber@thepearl.ky',
  },
  {
    id: 'paul-blount',
    name: 'Paul Blount',
    title: 'Co-Founder',
    bio: 'With over 25 years of experience in Caribbean luxury development, Paul brings a visionary approach to creating communities that blend modern living with island charm. His previous projects have set new standards for sustainable, high-end residential developments. Passionate about creating spaces where people truly want to live, work, and thrive.',
    initials: 'PB',
    linkedIn: 'https://linkedin.com/',
    email: 'paul.blount@thepearl.ky',
  },
  {
    id: 'david-thompson',
    name: 'David Thompson',
    title: 'Head of Architecture',
    bio: 'David leads our architectural vision, specializing in tropical modernism that respects the Caribbean environment while pushing design boundaries. His award-winning work emphasizes natural light, open spaces, and seamless indoor-outdoor living. Every line he draws is informed by 20 years of creating breathtaking spaces in island settings.',
    initials: 'DT',
    linkedIn: 'https://linkedin.com/in/davidthompson',
    email: 'david.thompson@thepearl.ky',
  },
];

export const partners: Partner[] = [
  {
    id: 'chaac',
    name: 'ChaAC I+N+C',
    category: 'Construction',
    logo: '/img/partner/chaac.png',
    url: 'http://www.chaac-inc.com/',
    description: 'ChaAC I+N+C is a digital twin and building performance consultancy based in Mérida, Mexico. We specialise in rigorous, simulation-driven analysis to support regulatory compliance, sustainability objectives, and high-stakes decision-making for code authorities, developers, and design teams. Our work reduces risk, streamlines approvals, and accelerates the achievement of green building certifications through data-led insight and technical precision.',
  },
  {
    id: 'reed-consulting',
    name: 'Reed Consulting Engineers',
    category: 'Engineering',
    logo: '/img/partner/reed.png',
    url: 'https://www.reedconsultingengineers.com/',
    description: 'Reed Consulting Engineers provides integrated structural, MEPF, civil, and environmental services to the Cayman Islands and wider Caribbean—offering developers clear accountability and streamlined coordination from concept to completion. Our multidisciplinary team draws on global experience across commercial, multifamily residential, institutional, and infrastructure projects, bringing unified, interdisciplinary thought to every design decision and delivering resilient, dependable outcomes.',
  },
];
